export const BOARD_SIZE = 5;
export const WIN_LENGTH = 4;
export const EMPTY_CELL = null;

// AI difficulty thresholds (0..1).
export const TICTACTOE_AI_HARD_DIFFICULTY_THRESHOLD = 0.9;
export const TICTACTOE_AI_MEDIUM_FORK_AVOIDANCE_THRESHOLD = 0.4;
export const TICTACTOE_AI_MEDIUM_OPENING_BOOK_START = 0.4;
export const TICTACTOE_AI_MEDIUM_OPENING_BOOK_END = 0.7;
